/* eslint-disable unicorn/filename-case */
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type FlashMessageService from 'ember-cli-flash/services/flash-messages';
import { tracked } from 'tracked-built-ins';

interface PagesAboutUsIndexArgs {}

export default class PagesAboutUsIndex extends Component<PagesAboutUsIndexArgs> {
  @service declare router: RouterService;
  @service declare flashMessages: FlashMessageService;
  @tracked swiperOptions = {
    pagination: true,
    keyboard: true,
    loop: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    cssMode: true,
    speed: 2000,
    autoplay: {
      delay: 3000,
    },
  };
}
